import getBookingServices from '../services/getBookingServices';
import setIsPerformingServiceUpdate from '../data/actions/setIsPerformingServiceUpdate';
import loadServices from '../data/actions/loadServices';
import { trace } from 'owa-trace';

/**
 * Triggers a service call to get the booking services.
 */
export default async function getServices() {
    try {
        setIsPerformingServiceUpdate(true);
        let result = await getBookingServices();
        if (result) {
            loadServices(result.Services);
        }
    } catch (e) {
        trace.warn(e.message || 'getServices failed');
    } finally {
        setIsPerformingServiceUpdate(false);
    }
}
